export const researcherFormResetList = ['coResearcher']
